<template>
	<!-- 公司形象 -->
	<div class="image">
		
		<!-- 头部 -->
		<zmlmenupage cn-name='企业形象' en-name='Corporate Image'></zmlmenupage>
		
		<zmlpagebanner
		banner-img='static/img/aboutBanner.png' 
		banner-text='货运江湖，一键启航！' 
		cn-name='企业形象' 
		en-name='Corporate Image'>
		</zmlpagebanner>
		
		<div class="image-con">
			<div class="info imageInfo">
				<div class="image-title">企业形象</div>
				<div class="image-content flexBetween">
					<div class="image-box1">
						<div class="image-item">
							<img src="../../static/img/image9.png" alt=""/>
							<p>颁奖典礼</p>
						</div>
					</div>
					<div class="flexBetween myimage-scroll">
						<el-scrollbar>
							<div class="image-box2">
								<div class="image-item">
									<img src="../../static/img/1.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/2.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/3.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/4.jpg" alt=""/>
									<p>办公室</p>
								</div>
							</div>
							<div class="image-box3">
								<div class="image-item">
									<img src="../../static/img/5.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/6.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/7.jpg" alt=""/>
									<p>办公室</p>
								</div>
								<div class="image-item">
									<img src="../../static/img/8.jpg" alt=""/>
									<p>办公室</p>
								</div>
							</div>
						</el-scrollbar>
					</div>
				</div>
				<!-- <router-link to="" class="findMore">查看更多</router-link> -->
			</div>
			
		</div>
		<gototop></gototop>
		
	</div>
</template>
<script>
  export default{
	name: 'myimage',
    data(){
      return{

      }
    }
  }
</script>
<style scoped="scoped">
.image-title{
	font-size: 28px;
	font-weight: bold;
	padding: 100px 0px 58px;
}
.imageInfo{
	padding-bottom: 160px;
}
.image-content{
	overflow: hidden;
}
.image-box1{
	width: 400px;
	height: auto;
	margin-top: 188px;
}
.image-box2{
	width: 420px;
	height: auto;
	/* margin-top: 100px; */
	margin-left: 80px;
}
.image-box3{
	width: 420px;
	height: auto;
	margin-left: 80px;
}
.image-item{
	margin-bottom: 80px;
}
.image-item img{
	width: 100%;
}
.image-item p{
	padding: 23px 0px 11px;
	border-bottom: 1px solid #EFEFEF;
	font-size: 16px;
	color: #666;
}
.myimage-scroll{
	flex: 1;
	max-height: 850px;
	overflow-y: auto;
}
>>>.el-scrollbar{
	width: 100%;
	height: 100%;
}
>>>.el-scrollbar__wrap{
	overflow-x: hidden;
}
>>>.el-scrollbar__view{
	display: flex;
	justify-content: space-between;
}
>>>.el-scrollbar__bar.is-vertical{
	display: none;
}

@media only screen and (max-width: 750px){
	.image-title{
		display: block;
		padding: 23px 0;
		font-size: 14px;
		font-weight: bold;
	}
	.flexBetween{
		display: block;
	}
	.image-box1,
	.image-box2,
	.image-box3{
		width: 100%;
		margin-top: 0;
		margin-left: 0;
	}
	.image-item{
		margin-bottom: 40px;
	}
	.imageInfo{
		padding-bottom:80px ;
	}
	>>>.el-scrollbar__view{
		display: block;
	}
	.myimage-scroll{
		max-height: 100% !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/myimage.vue